import * as actionTypes from './actionTypes'

export const ftCloseModal = (params) => (dispatch, getState) => {
  let state = getState()
  dispatch(closeModal(params))
  if (window.parent && window.parent.__FT_PROJECT__API__ && window.parent.__FT_PROJECT__API__.FTCloseParentModal) {
    try {
      if (window.location.href == window.parent.location.href) {
        return false
      }
      window.parent.__FT_PROJECT__API__.FTCloseParentModal(state.getIn(['params']).toJS())
    } catch (err) {
      console.error(err)
    }
  }
}
export const closeModal = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.REDIRECT_MODAL_CLOSE,
    payload: {
      params: params,
    },
  })
}
